module.exports = {
	"name": "doppiojvm",
	"version": "0.5.0",
	"engine": "node >= 6.0.0",
	"license": "MIT",
	"main": "dist/release/doppio.js",
	"typings": "dist/typings/src/doppiojvm",
	"dependencies": {
		"async": "^2.0.0",
		"browserfs": "^1.0.0",
		"glob": "^7.1.1",
		"gunzip-maybe": "^1.3.1",
		"optimist": "~0.6",
		"pako": "^1.0.3",
		"rimraf": "^2.5.4",
		"source-map-support": "^0.4.3",
		"tar-fs": "^1.13.2"
	},
	"devDependencies": {
		"@types/async": "^2.0.32",
		"@types/body-parser": "0.0.33",
		"@types/dropboxjs": "0.0.29",
		"@types/esprima": "^2.1.33",
		"@types/express": "^4.0.33",
		"@types/express-serve-static-core": "^4.0.37",
		"@types/filesystem": "0.0.28",
		"@types/glob": "^5.0.30",
		"@types/grunt": "^0.4.20",
		"@types/jasmine": "^2.5.35",
		"@types/karma": "^0.13.33",
		"@types/node": "6.0.33",
		"@types/rimraf": "0.0.28",
		"@types/semver": "^5.3.30",
		"@types/serve-static": "^1.7.31",
		"@types/source-map": "^0.1.28",
		"@types/uglify-js": "^2.6.28",
		"@types/underscore": "^1.7.33",
		"@types/webpack": "^1.12.35",
		"body-parser": "^1.15.2",
		"cpr": "^2.0.0",
		"detect-browser": "^1.3.1",
		"escodegen": "^1.8.1",
		"esprima": "^3.1.0",
		"estraverse": "^4.2.0",
		"express": "^4.13.4",
		"grunt": "^1.0",
		"grunt-cli": "^1.2",
		"grunt-contrib-compress": "^1.2.0",
		"grunt-contrib-connect": "^1.0",
		"grunt-contrib-copy": "^1.0",
		"grunt-contrib-uglify": "^2.0",
		"grunt-karma": "^2.0",
		"grunt-lineending": "^1.0.0",
		"grunt-merge-source-maps": "^0.1.0",
		"grunt-newer": "^1.2.0",
		"grunt-ts": "6.0.0-beta.3",
		"grunt-webpack": "^1.0.17",
		"imports-loader": "^0.6.5",
		"jasmine-core": "^2.5.2",
		"json-loader": "^0.5.4",
		"karma": "^1.3.0",
		"karma-chrome-launcher": "^2.0",
		"karma-firefox-launcher": "^1.0",
		"karma-ie-launcher": "^1.0",
		"karma-jasmine": "^1.0",
		"karma-opera-launcher": "^1.0",
		"karma-safari-launcher": "^1.0",
		"locate-java-home": "^0.1.6",
		"semver": "^5.3.0",
		"source-map-loader": "^0.1.5",
		"typescript": "^2.0.3",
		"uglify-js": "^2.7.3",
		"underscore": "^1.8.3",
		"webpack": "^1.13.1",
		"webpack-dev-server": "^1.16.2"
	},
	"scripts": {
		"test": "grunt test",
		"prepublish": "node ./prepublish.js",
		"install": "node ./install.js",
		"appveyor-test": "grunt --stack test-browser-appveyor"
	},
	"repository": {
		"type": "git",
		"url": "http://github.com/plasma-umass/doppio.git"
	},
	"bin": {
		"doppio": "./bin/doppio",
		"doppioh": "./bin/doppioh",
		"doppio-dev": "./bin/doppio-dev",
		"doppio-fast-dev": "./bin/doppio-fast-dev"
	}
};


//////////////////
// WEBPACK FOOTER
// ./package.json
// module id = 35
// module chunks = 0